// const rootURL = `https://restapi.deviapp.in`
const rootURL = `https://dadpapi.vbbsolutions.in`
// const rootURL = `http://localhost:3002`
export const configSettings = {
    appURL: rootURL,
    mediaURL: `${rootURL}/media`
}